module.exports = __webpack_public_path__ + "static/media/iStock-642445228.d757e6f0.jpg";